import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator, Logger } from '@ngrx/data';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

const headers = {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    'Access-Control-Allow-Origin': '*',
};

@Injectable()
export class SwayTicketDataService extends DefaultDataService<any> {
    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, logger: Logger) {
        super('TicketCount', http, httpUrlGenerator);
        logger.log('Created custom Ticket EntityDataService');
    }

    override getWithQuery(params: { msp: string; tenant: string; start: string; end: string }): Observable<any[]> {
        return this.http
            .get<any>(
                `/api/report/msp/${params.msp}/tenant/${params.tenant}/tickets/count?start=${encodeURIComponent(params.start)}&end=${encodeURIComponent(params.end)}`,
                {
                    headers: {
                        ...headers,
                        'msp-id': params.msp,
                        'tenant-id': params.tenant,
                    },
                },
            )
            .pipe(
                catchError((err) => {
                    console.log('[error] SwayTicketDataService:', JSON.stringify(err));
                    return of(err);
                }),
            );
    }
}
